import { TimelineParty } from '../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export interface PartyApproval {
    isApproved: boolean;
    approvedAt?: Date;
    approvedByUserId?: number;
}

/**
 * Tri-state used by the flow-of-funds tables, where a party can explicitly
 * reject as well as approve — `PartyApproval.isApproved` alone cannot express
 * "rejected" separately from "not yet decided".
 */
export enum ApprovalState {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
}

export { TimelineParty as MarketplaceParty };
